import { render, staticRenderFns } from "./jenis.vue?vue&type=template&id=74759d06&"
import script from "./jenis.vue?vue&type=script&lang=js&"
export * from "./jenis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports